import { createSelector } from 'reselect'
import { TopicRootState } from '../topicRoot.reducer'

export const getTheme = createSelector(
  (state: TopicRootState) => state.commonStore.theme,
  (state) => state,
)

export const getUser = createSelector(
  (state: TopicRootState) => state.commonStore.user,
  (state) => state,
)

export const getLicensePermissions = createSelector(
  (state: TopicRootState) => state.commonStore.licensePermissions,
  (state) => state,
)

export const namedRequestInProgress = createSelector(
  [
    (state: TopicRootState) => state.commonStore.requests,
    (state: TopicRootState, type: string) => type,
  ],
  (state, type) => {
    return state.filter(request => request.type === type && request.inProgress).length > 0
  },
)

export const namedRequestData = createSelector(
  [
    (state: TopicRootState) => state.commonStore.requests,
    (state: TopicRootState, type: string) => type,
  ],
  (state, type) => {
    return state.find(request => request.type === type)
  },
)
